/**
 * Andre Garen - Sepet.
 * Gercek Shopify Cart AJAX API'si; sayfa yenilenmez.
 * Cekmece icerigi `sections: ag-cart-items` ile sunucudan yeniden boyanir.
 */
(function () {
  'use strict';

  var SECTION = 'ag-cart-items';
  var drawer, body, foot, totalEl, titleEl;
  var busy = false;
  /* Faz 8 Süsleme Paket 2, madde 09 (15 Eylul): rozet sadece GERÇEK artışta
     ("is-bump") zıplasın - azalma/kaldırmada tetiklenmemeli. Sayfa yüklenirken
     sunucunun zaten yazdığı ilk değerden başlar, boot() bunu ilk render'da okur. */
  var lastCartCount = null;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function refs() {
    drawer = q('[data-ag-drawer]');
    /* Görev (Sepet, 21 Eylul): /cart sayfası aynı [data-ag-cart-body]/
       [data-ag-cart-total] attribute'larını PAYLAŞIYOR (çekmece görünmez
       olsa da DOM'da her zaman var) - tek bir AJAX yanıtı artık HER İKİ
       yeri de boyayabilsin diye querySelector -> querySelectorAll'a
       çevrildi. Cart API/add/change/busy/toast mantığına dokunulmadı. */
    body = qa('[data-ag-cart-body]');
    foot = q('[data-ag-cart-foot]');
    totalEl = qa('[data-ag-cart-total]');
    /* Görev (Sepet, 21 Eylul): sepet çekmecesi başlığındaki "N ürün" metni
       (drawer'da zaten vardı, hiç JS'e bağlı değildi - /cart sayfası
       başlığı da aynı attribute'u kullanıyor) artık AJAX'tan sonra da
       güncelleniyor. count===0 iken gizleniyor (boş durumun kendi mesajı
       zaten görünüyor). */
    titleEl = qa('[data-ag-cart-title]');
  }

  function setBusy(on) {
    busy = on;
    if (drawer) {
      if (on) drawer.setAttribute('data-busy', '1');
      else drawer.removeAttribute('data-busy');
    }
  }

  var opener = null;
  function open() {
    refs();
    if (!drawer) return;
    if (drawer.hidden) opener = opener || document.activeElement;
    drawer.hidden = false;
    drawer.setAttribute('data-open', '1');
    document.body.style.overflow = 'hidden';
    var close = q('[data-ag-cart-close]', drawer);
    if (close && close.focus) close.focus();
  }

  function close() {
    if (!drawer) refs();
    if (!drawer) return;
    drawer.removeAttribute('data-open');
    drawer.hidden = true;
    document.body.style.overflow = '';
    if (opener && opener.focus && document.contains(opener)) { try { opener.focus({ preventScroll: true }); } catch (x) {} }
    opener = null;
  }

  /** Sunucudan gelen bolum HTML'ini cekmeceye yerlestirir. */
  function apply(sectionHtml) {
    refs();
    var wrap = document.createElement('div');
    wrap.innerHTML = sectionHtml;
    var payload = wrap.querySelector('[data-ag-cart-payload]');
    if (!payload) return;

    var count = parseInt(payload.getAttribute('data-count'), 10) || 0;
    var total = payload.getAttribute('data-total') || '';

    body.forEach(function (b) { b.innerHTML = payload.innerHTML; });
    totalEl.forEach(function (t) { t.textContent = total; });
    titleEl.forEach(function (t) { t.hidden = count === 0; if (count > 0) t.textContent = count + ' ' + 'ürün'; });
    if (foot) foot.hidden = count === 0;

    var didIncrease = lastCartCount !== null && count > lastCartCount;
    qa('[data-ag-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
      if (didIncrease) {
        el.classList.remove('is-bump');
        void el.offsetWidth; /* reflow - ust uste hizli eklemede animasyonu yeniden baslatir */
        el.classList.add('is-bump');
      }
    });
    lastCartCount = count;

    document.dispatchEvent(new CustomEvent('ag:cart:updated', { detail: { count: count } }));
  }

  function request(url, payload) {
    payload.sections = SECTION;
    payload.sections_url = window.location.pathname;
    setBusy(true);
    /* Tur 12 A: ag hatasi / JSON olmayan yanit (5xx HTML) / yanitsiz istek kullaniciya teknik Ingilizce mesaj
       gosteriyor ya da dugmeyi "Ekleniyor..." durumunda kilitli birakiyordu. Artik 15 sn zaman asimi var ve bu
       durumlarda mevcut genel mesaj gosterilir; Shopify'in kendi (JSON) hata aciklamasi aynen korunur. */
    var GENEL = 'Sepet güncellenemedi.';
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, 15000) : null;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
      signal: ctl ? ctl.signal : undefined
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, data: d }; }, function () { return { ok: false, data: null }; });
      }, function () { throw new Error(GENEL); })
      .then(function (res) {
        clearTimeout(timer);
        setBusy(false);
        if (!res.ok) {
          var msg = res.data && (res.data.description || res.data.message);
          /* Tur 23 EK9 (Test Odasi H007): Shopify uyarisi siz diliyle gelir - sen diline cevrilir */
          if (msg) msg = String(msg).replace(/sepetinize/g, 'sepetine').replace(/Sepetinize/g, 'Sepetine').replace(/yaln\u0131zca/g, 'yaln\u0131z').replace(/ \u00fcr\u00fcn eklendi/g, ' par\u00e7a eklendi');
          throw new Error(msg || GENEL);
        }
        if (res.data.sections && res.data.sections[SECTION]) apply(res.data.sections[SECTION]);
        return res.data;
      })
      .catch(function (err) {
        clearTimeout(timer);
        setBusy(false);
        throw err;
      });
  }

  function add(items) {
    return request('/cart/add.js', { items: items });
  }

  function change(key, quantity) {
    return request('/cart/change.js', { id: key, quantity: quantity });
  }

  /* ---------------- olaylar ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    if (t.closest('[data-ag-cart-open]')) { e.preventDefault(); opener = t.closest('[data-ag-cart-open]'); open(); return; } /* Safari tiklamada odak vermez: acan dugme dogrudan */
    if (t.closest('[data-ag-cart-close]')) { e.preventDefault(); close(); return; }

    var qty = t.closest('[data-ag-qty]');
    if (qty && !busy) {
      e.preventDefault();
      var n = parseInt(qty.getAttribute('data-ag-qty'), 10);
      var key = qty.getAttribute('data-ag-line-key');
      if (key && !isNaN(n)) change(key, n).catch(function (err) { announce(err.message); });
      return;
    }

    var addBtn = t.closest('[data-ag-add]');
    if (addBtn && addBtn.getAttribute('data-ag-sepette') === '1') { e.preventDefault(); open(); return; } /* A4: sepetteki varyant - cekmece acilir, tekrar eklenmez */
    if (addBtn) {
      /* Denetim (pre-launch audit, P1): preventDefault eskiden "!busy"
         kontrolunun ICINDEYDI - onceki istek uctayken (busy=true) gelen
         ikinci tiklama bu bloga hic girmiyor, preventDefault hic
         cagrilmiyordu; buton bir <button type="submit"> oldugu icin
         tarayici formu native submit ediyor, action'siz form kendi
         URL'ine GET ile sayfayi yeniden yukluyordu (sepete ekleme yarim
         kaliyordu). preventDefault artik busy kontrolunden ONCE, HER
         tiklamada cagriliyor - ayrica butonun kendisi artik type="button"
         (bkz. ag-product.liquid), bu yuzden native submit yolu zaten
         tamamen kapali; ikisi birlikte cift koruma sagliyor. */
      e.preventDefault();
      if (busy) return;
      if (addBtn.getAttribute('aria-disabled') === 'true' || addBtn.disabled || addBtn.hasAttribute('data-ag-notify-trigger')) return;
      var id = addBtn.getAttribute('data-ag-add');
      if (!id) return;
      var q1 = parseInt(addBtn.getAttribute('data-ag-quantity'), 10) || 1;
      var original = addBtn.getAttribute('data-ag-label-default') || addBtn.textContent;
      addBtn.setAttribute('data-ag-label-default', original);
      addBtn.setAttribute('aria-busy', 'true');
      addBtn.textContent = addBtn.getAttribute('data-ag-label-adding') || 'Ekleniyor…';
      /* Tur 23 EK1 K4: cekmece sunucu yanitini BEKLEMEDEN dokunusta acilir (olcum: /cart/add.js 4G'de ~1.2 sn,
         sunucu ~0.4 sn - cekmece eskiden ancak yanittan sonra aciliyordu). Yanit gelene kadar ustte
         "Ekleniyor..." satiri, eski icerik soluk (data-busy); yanitla icerik yenilenir, hata satirda yazar. */
      var openNow = addBtn.getAttribute('data-ag-open-drawer') !== 'false';
      var istek = add([{ id: Number(id), quantity: q1 }]); /* once istek, sonra cekmece */
      if (openNow) { open(); pending(addBtn.getAttribute('data-ag-label-adding') || 'Ekleniyor…'); }
      istek
        .then(function () {
          pending(null);
          addBtn.removeAttribute('aria-busy');
          addBtn.textContent = addBtn.getAttribute('data-ag-label-added') || 'Sepete eklendi ✓';
          /* Tur 23 EK1 K4: cekmece dokunusta acildi; kullanici bu arada kapattiysa yeniden acilmaz */
          setTimeout(function () {
            /* Denetim (25 Ağustos sabah, madde 3; süre Faz 8 Süsleme Paket 2
               madde 09'da 2.2sn'den 2.5sn'ye guncellendi): "Sepete eklendi ✓"
               bu sürenin sonunda kosulsuz "original" etikete donuyordu - ama bu surede
               kullanici AYNI urunde baska (stokta olmayan) bir varyant
               secerse, ag-product.js'in render()'i butonu zaten "Haber
               ver" etiketine cevirip disabled/aria-disabled="true"
               yapiyor. Bu setTimeout o durumu fark etmeden ustune yazip
               butonu "Sepete Ekle" gosterip aslinda tiklanamaz/bildirim
               modunda birakiyordu. Buton bu arada disabled'a alindiysa
               (yani render() zaten kendi doğru etiketini yazdiysa) burada
               dokunulmuyor. */
            if (addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true' || addBtn.hasAttribute('data-ag-notify-trigger')) return;
            if (addBtn.getAttribute('data-ag-label-added') === 'Sepette \u2713') return; /* Gezi A8: urun sayfasinda kalir (beden degisince render() yeniler) */
            addBtn.textContent = original;
          }, 2500);
        })
        .catch(function (err) {
          addBtn.removeAttribute('aria-busy');
          addBtn.textContent = original;
          if (openNow) pending(err.message, true);
          announce(err.message);
        });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.getAttribute('data-open') === '1') close();
    if (e.key === 'Tab' && drawer && drawer.getAttribute('data-open') === '1') { var f = [].filter.call(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null; }); if (f.length) { e.preventDefault(); var i = f.indexOf(document.activeElement); f[i < 0 ? 0 : (i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus(); } }
  });

  /* Tur 23 EK1 K4: cekmece govdesinin USTUNDE bekleme/hata satiri (govde mesgulken soluk, bu satir degil) */
  function pending(msg, hata) {
    refs();
    if (!drawer) return;
    var el = q('[data-ag-cart-pending]', drawer);
    if (!msg) { if (el && !el.__hata) el.remove(); return; }
    var bodyEl = q('[data-ag-cart-body]', drawer);
    if (!el && bodyEl) {
      el = document.createElement('p');
      el.className = 'ag-drawer__pending';
      el.setAttribute('data-ag-cart-pending', '');
      el.setAttribute('role', 'status');
      bodyEl.parentNode.insertBefore(el, bodyEl);
    }
    if (!el) return;
    el.__hata = !!hata;
    el.classList.toggle('ag-drawer__pending--hata', !!hata);
    el.textContent = msg;
    if (hata) setTimeout(function () { if (el.parentNode) el.remove(); }, 5000);
  }

  /* ---- kucuk bildirim ---- */
  function announce(msg) {
    var el = q('[data-ag-toast]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-ag-toast', '');
      el.setAttribute('role', 'status');
      el.style.cssText =
        'position:fixed;left:50%;bottom:22px;transform:translateX(-50%);z-index:200;' +
        'background:var(--ag-fg);color:var(--ag-bg);padding:.7rem 1.1rem;font-size:.66rem;' +
        'letter-spacing:.06em;max-width:88vw;text-align:center;pointer-events:none'; /* Tur 9 T9-038: soldugunda (opacity 0) DOM'da kalip alt-orta bolgedeki tiklamalari yutuyordu */
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.style.opacity = '1';
    clearTimeout(el.__t);
    el.__t = setTimeout(function () { el.style.opacity = '0'; }, 3200);
  }

  window.AGCart = { open: open, close: close, add: add, change: change, announce: announce };

  /* Acilis gecesi A4: urun sayfasinda secili varyant sepetteyse ana ve yapiskan dugme "Sepette ✓", degilse "Sepete Ekle"; beden/renk degisince yeniden hesaplanir */
  var sepetIds = null, SEPETTE = 'Sepette \u2713';
  function sepetteIsaretle() {
    qa('.ag-product__atc[data-ag-add], [data-ag-stickyatc-btn]').forEach(function (b) {
      var id = b.getAttribute('data-ag-add'), var_ = !!(id && sepetIds && sepetIds.indexOf(String(id)) > -1 && !b.hasAttribute('data-ag-notify-trigger'));
      if (var_) {
        if (b.getAttribute('data-ag-sepette') !== '1') { b.__etiket = b.innerHTML; b.setAttribute('data-ag-sepette', '1'); }
        if (b.textContent.trim() !== SEPETTE) b.textContent = SEPETTE;
      } else if (b.getAttribute('data-ag-sepette') === '1') {
        b.removeAttribute('data-ag-sepette');
        if (b.textContent.trim() === SEPETTE && b.__etiket) b.innerHTML = b.__etiket;
      }
    });
  }
  function sepetOku() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      sepetIds = (c.items || []).map(function (i) { return String(i.variant_id); }); sepetteIsaretle();
    }).catch(function () {});
  }
  function sepetBaslat() {
    var btns = qa('.ag-product__atc[data-ag-add], [data-ag-stickyatc-btn]'); if (!btns.length) return;
    sepetOku(); document.addEventListener('ag:cart:updated', sepetOku);
    if (window.MutationObserver) { var mo = new MutationObserver(function () { sepetteIsaretle(); }); btns.forEach(function (b) { mo.observe(b, { attributes: true, attributeFilter: ['data-ag-add', 'data-ag-notify-trigger'] }); }); }
    window.addEventListener('pageshow', function (e) { if (e.persisted) sepetOku(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sepetBaslat); else sepetBaslat();

  function initCount() {
    refs();
    var badge = q('[data-ag-cart-count]');
    lastCartCount = badge ? parseInt(badge.textContent, 10) || 0 : 0;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCount);
  else initCount();
})();